import { AnimatePresence, motion, useReducedMotion } from 'motion/react';
import { motionDuration, motionEase } from '@/features/ui/motion/motion-tokens';

type Props = {
  title: string;
  className?: string;
};

/** Fade du titre header quand la route change. */
export function AnimatedPageTitle({ title, className = 'header-title' }: Props) {
  const reduceMotion = useReducedMotion();

  return (
    <AnimatePresence mode="wait" initial={false}>
      <motion.h1
        key={title}
        className={className}
        initial={reduceMotion ? { opacity: 0 } : { opacity: 0, y: 4 }}
        animate={{ opacity: 1, y: 0 }}
        exit={reduceMotion ? { opacity: 0 } : { opacity: 0, y: -4 }}
        transition={{ duration: motionDuration.fast, ease: motionEase }}
      >
        {title}
      </motion.h1>
    </AnimatePresence>
  );
}
